import { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';

export default function useHideFilter() {
  const position = useRef(window.scrollY);
  const hidingPosition = useRef(window.scrollY);
  const [visible, setVisible] = useState(true);
  const modals = useSelector(state => state.modals);

  const isSomeFilterOpen = Object.values({...modals.mainFilter, ...modals.secondaryFilter}).some(filter => filter);

  const handleScroll = useCallback(() => {
    const resultElementPosition = document.getElementsByName('scrollToResults')[0]?.offsetTop;
    const currentScrollY = window.scrollY;
    let shouldShow = visible;

    if (isSomeFilterOpen) { // || resultElementPosition + 200 > currentScrollY) {
      shouldShow = true;
    } else {
      if (hidingPosition.current > currentScrollY) {
        shouldShow = (hidingPosition.current - 100 > currentScrollY) || (position.current < resultElementPosition);
      } else {
        shouldShow = (position.current > currentScrollY);// || (position.current < resultElementPosition + 350);
      }
    }

    if (position.current < currentScrollY) {
      hidingPosition.current = currentScrollY;
    }

    position.current = currentScrollY;

    if (shouldShow !== visible) {
      setVisible(shouldShow);
    }
  }, [visible, isSomeFilterOpen]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return visible;
}
